import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const words = ["Wonder", "Explore", "Discover", "Tinker", "Grow"];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="border-y border-ink/10 bg-sand py-7"
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {words.map((w) => (
        <span key={w} className="mx-16 flex items-center gap-16">
          <span className="font-serif text-4xl italic tracking-tight text-ink/80 md:text-5xl">
            {w}
          </span>
          <Asterisk size={26} className="text-terracotta" />
        </span>
      ))}
    </Marquee>
  </div>
);
